export default {
  metadata: {
    version: '1.0.0',
    id: 'vertical-stepper-1.0.0',
    name: 'JDSVerticalStepper'
  },
  hierarchy: {
    container: ['jds_step_item_vertical']
  },
  base: {
    container: {
      'flex-direction': '{v_0}',
      'justify-content': '{v_1}',
      'align-items': '{v_2}',
      size: '{v_3}',
      gap: '{v_4}'
    },
    'label-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      language: 'en',
      'padding-top': 0
    }
  },
  api: {
    data: {
      container: {
        value: {
          type: 'list',
          name: 'stepItems',
          object: {
            state: 'JDSStepperDot.state',
            label: 'string',
            index: 'string',
            icon: 'icon',
            direction: 'JDSVerticalStepItem.direction',
            content: 'template',
            activeState: 'JDSStepperDot.activeState'
          }
        },
        'max-width': {
          name: 'maxWidth',
          type: 'size'
        }
      },
      jds_step_item_vertical: {
        state: {
          type: 'JDSStepperDot.state',
          name: 'stepItems.state'
        },
        label: {
          type: 'string',
          name: 'stepItems.label'
        },
        index: {
          type: 'string',
          name: 'stepItems.index'
        },
        icon: {
          type: 'icon',
          name: 'stepItems.icon'
        },
        direction: {
          type: 'JDSVerticalStepItem.direction',
          name: 'stepItems.direction'
        },
        content: {
          type: 'template',
          name: 'stepItems.content'
        },
        activeState: {
          type: 'JDSStepperDot.activeState',
          name: 'stepItems.activeState'
        },
        itemsType: {
          type: 'JDSStepperDot.itemsType',
          name: 'itemsType'
        }
      }
    },
    a11y: {
      container: {
        name: 'stepItems',
        repeating: {
          ariaLabel: 'stepItemAriaLabel',
          ariaCurrent: '_ariaCurrent'
        },
        properties: {
          role: {
            value: 'list'
          }
        }
      },
      jds_step_item_vertical: {
        properties: {
          ariaLabel: 'stepItems.stepItemAriaLabel',
          ariaCurrent: 'stepItems._ariaCurrent'
        }
      }
    }
  }
};
